export function castMediaError(error) {
    if (!error.name) {
        return {
            errorCode: 'MEDIA_ERROR',
            message: error.message || 'Get user media failure'
        };
    }
    switch (error.name) {
        case 'AbortError':
            return {
                errorCode: 'MEDIA_UNKNOWN_ERROR',
                message: 'Some unknown problem occurred that prevented your input device from being used.'
            };
        case 'NotAllowedError':
            return {
                errorCode: 'MEDIA_NOT_ALLOWED_ERROR',
                message: 'The current session does not have the permission to access your input device. Please allow access to your input device.'
            };
        // wait timer for user to give permission and retry
        case 'NotFoundError':
            return {
                errorCode: 'MEDIA_NOT_ALLOWED_ERROR',
                message: 'Your device does not appear to be available at this moment.'
            };
        // try next device
        case 'NotReadableError':
            return {
                errorCode: 'MEDIA_HARDWARE_ERROR',
                message: 'An hardware problem occurred that prevented your input device from being used.'
            };
        case 'OverConstrainedError':
            var errorMessage = '';
            if (error.message) {
                errorMessage = "No device match the current constraints: " + error.message + ".";
            }
            else {
                errorMessage = 'No device match the current constraints.';
            }
            return {
                errorCode: 'MEDIA_UNKNOWN_ERROR',
                message: errorMessage
            };
        case 'SecurityError':
            return {
                errorCode: 'MEDIA_NOT_ALLOWED_ERROR',
                message: 'The current seesion does not have the permission to access the input device.'
            };
        case 'TypeError':
            return {
                errorCode: 'MEDIA_UNKNOWN_ERROR',
                message: 'The list of constraint is empty.'
            };
        case 'not-installed':
            return {
                errorCode: 'SCREEN_SHARE_UNAVAILABLE',
                message: 'The screen share extension is not installed.'
            };
        case 'installed-disabled':
            return {
                errorCode: 'SCREEN_SHARE_DISABLED',
                message: 'The screen share extension is disabled. Please enable it to use this feature.'
            };
        case 'jive-me-screen-permission-denied':
            return {
                errorCode: 'SCREEN_SHARE_PERMISSION_DENIED',
                message: 'Screen share was denied.'
            };
        case 'permission-denied':
            return {
                errorCode: 'SCREEN_SHARE_PERMISSION_DENIED',
                message: 'Screen share was denied.'
            };
        case 'not-chrome':
            return {
                errorCode: 'SCREEN_SHARE_INVALID_BROWSER',
                message: 'This browser does not support screen share.'
            };
        case 'ExtensionTimeout':
            return {
                errorCode: 'SCREEN_SHARE_EXTENSION_NOT_RESPONDING',
                message: 'The screen share extension is not responding and may be uninstalled or disabled.'
            };
        default:
            return {
                errorCode: 'MEDIA_ERROR',
                message: error.name + ": " + (error.message || 'Get user media failure')
            };
    }
}
//# sourceMappingURL=RTCMediaErrors.js.map